var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GoBack"},[_c('div',{staticClass:"back",on:{"click":_vm.goback}},[_c('img',{attrs:{"src":"https://oss.sbooip.com/static/www/pc/assets/images/back.png","alt":""}}),_c('div',[_vm._v("返回上一页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }